<template>
  <SettingsLayout :role="role" :user="user" @select="handleSelect" @update-prfile="handleUpdate">
    <component :is="currentComponent" :profile="profile" @update-prfile="handleUpdate" />
  </SettingsLayout>
</template>

<script>
import { markRaw } from "vue";
import ParentForm from "@/components/settings/student/ParentForm.vue";
import StudentProfileForm from "@/components/settings/student/ProfileForm.vue";
import SettingsLayout from "@/layout/SettingsLayout.vue";
import SecurityForm from "@/components/settings/student/SecurityForm.vue";
import PhotoForm from "@/components/settings/student/PhotoForm.vue";
import SubscriptionPage from "@/components/settings/student/subscription/SubscriptionPage.vue";
import PaymentMethodPage from "@/components/settings/student/PaymentMethodPage.vue";
import { useAuthStore } from "@/stores/authStore";
import { getProfile, updateProfile } from "@/api/student";
import { useRouter } from "vue-router";
import { notifyError, notifySuccess } from "@/utils/notification";

export default {
  components: {
    SettingsLayout,
    PaymentMethodPage,
  },
  data() {
    return {
      userId: undefined,
      role: "student",
      user: null,
      currentComponent: markRaw(StudentProfileForm),
      componentMap: {
        StudentProfileForm: markRaw(StudentProfileForm),
        ParentForm: markRaw(ParentForm),
        SecurityForm: markRaw(SecurityForm),
        PhotoForm: markRaw(PhotoForm),
        SubscriptionPage: markRaw(SubscriptionPage),
        PaymentMethodPage: markRaw(PaymentMethodPage),
      },
    };
  },
  mounted() {
    this.userId = useAuthStore().user.userId;
    if (!this.userId) {
      this.userId = useAuthStore().user._id;
    }
    if(!this.userId){
      useRouter().push("/login")
      return
    }
    this.role = useAuthStore().user.role;
    this.user = useAuthStore().user;
    this.fetchUserData();
  },
  computed: {
    profile() {
      return useAuthStore().user;
    }
  },
  methods: {
    async fetchUserData() {
      const user = await getProfile();
      useAuthStore().updateLocalUser(user.data.data);
    },
    async handleUpdate(payload) {
      try{
      await updateProfile(payload);
      notifySuccess("Success", "Your profile has been updated.");
      await this.fetchUserData();
      } catch {
        notifyError("Oops! Something went wrong","We couldn’t complete your request. Please try again or contact support if the problem persists.");
      }
    },
    handleSelect(componentName) {
      this.currentComponent = this.componentMap[componentName] || this.componentMap.StudentProfileForm;
    },
  },
};
</script>
